import allRoutes from "../routes";
import axios from "axios";

const alwaysInclude = ["dashboard", "sign in", "sign up"];

const normalize = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const readStoredModules = () => {
  const stored = sessionStorage.getItem("modulefunctions");
  if (!stored) return null;

  try {
    const modules = JSON.parse(stored);
    return Array.isArray(modules) ? modules : null;
  } catch {
    return null;
  }
};

const fetchModulesFromDb = async () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const storedUser = sessionStorage.getItem("user");
  if (!API_BASE_URL || !storedUser) return null;

  try {
    const user = JSON.parse(storedUser);
    if (!user?.user_id) return null;

    const response = await axios.get(`${API_BASE_URL}/api/rbac/user/${user.user_id}/modules`);
    const modules = response.data?.modules;
    if (!Array.isArray(modules)) return null;

    sessionStorage.setItem("modulefunctions", JSON.stringify(modules));
    return modules;
  } catch {
    return null;
  }
};

export default async function getFilteredRoutes() {
  const moduleFunctions = (await fetchModulesFromDb()) ?? readStoredModules();

  if (!moduleFunctions) {
    return allRoutes.filter((route) => alwaysInclude.includes(normalize(route.name)));
  }

  const allowedModules = moduleFunctions.map((mod) => normalize(mod.module_name));
  const validModules = new Set([...allowedModules, ...alwaysInclude]);

  return allRoutes.filter((route) => validModules.has(normalize(route.name)));
}
